module.exports = __webpack_public_path__ + "img/video-icon-calllog.666951fd.svg";